import React from 'react';
import './CategoryTiles.css';

interface Category {
  name: string;
  emoji: string;
  color: string;
  count?: number;
}

interface CategoryTilesProps {
  onSelectCategory: (category: string | null) => void;
  selectedCategory: string | null;
  categories: Category[];
  totalCount?: number;
}

const CategoryTiles: React.FC<CategoryTilesProps> = ({ 
  onSelectCategory, 
  selectedCategory,
  categories,
  totalCount 
}) => {
  return (
    <div className="category-tiles">
      <h3 className="category-title">Browse by Interest</h3>
      <div className="tiles-grid">
        <div 
          className={`category-tile ${selectedCategory === null ? 'active' : ''}`}
          onClick={() => onSelectCategory(null)}
          style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
        >
          <div className="tile-emoji">🎉</div>
          <div className="tile-name">All Events</div>
          {totalCount !== undefined && (
            <div className="tile-count">{totalCount}</div>
          )}
        </div>
        {categories.map((category) => (
          <div
            key={category.name}
            className={`category-tile ${selectedCategory === category.name ? 'active' : ''}`}
            onClick={() => onSelectCategory(category.name)}
            style={{ background: category.color }}
          >
            <div className="tile-emoji">{category.emoji}</div>
            <div className="tile-name">{category.name}</div>
            {category.count !== undefined && (
              <div className="tile-count">{category.count}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoryTiles;
